import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-noRegistryAccess',
  templateUrl: './noRegistryAccess.component.html',
})
export class NoRegistryAccessComponent {
  public errorMessage: string;

  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      var errorId = params['errorid'];

      switch (errorId) {
        case 1:
          this.errorMessage = 'You must successfully complete the Data Entry Exam to continue to add or edit Registry data';
          break;
        case 2:
          this.errorMessage = '';
          break;
        case 3:
          this.errorMessage = 'Center membership expired, please renew center membership';
          break;
      }
    });
  }



  redrectToElsoWebste() {
    window.location.href = 'https://elso.org';
  }
}
